function toFiniteNumber(value) {
    if (value === null || value === undefined || value === '') {
        return null;
    }

    const number = Number(value);
    return Number.isFinite(number) ? number : null;
}

function toPositiveNumber(value) {
    const number = toFiniteNumber(value);
    return number !== null && number > 0 ? number : 0;
}

function getAvailablePointsBudget(points) {
    if (!points || !toPositiveNumber(points.points_ex_rate)) {
        return 0;
    }

    const balance = toPositiveNumber(points.balance);
    const max_cap = toFiniteNumber(points.max_cap);
    return max_cap !== null && max_cap >= 0 ? Math.min(balance, max_cap) : balance;
}

function splitPriceWithPoints({ total_price, budget_points, points_ex_rate } = {}) {
    const price = toFiniteNumber(total_price);
    const budget = toPositiveNumber(budget_points);
    const per_point = toPositiveNumber(points_ex_rate);

    if (price === null || price < 0 || !budget || !per_point) {
        return null;
    }

    const points_cash_value = Math.min(budget * per_point, price);

    return {
        points_spent: Math.floor(points_cash_value / per_point),
        points_cash_value,
        remaining_cash: price - points_cash_value,
    };
}

function buildPointsRecheckSplit({ old_total_price, new_total_price, budget_points, points_ex_rate } = {}) {
    const old_split = splitPriceWithPoints({ total_price: old_total_price, budget_points, points_ex_rate });
    const new_split = splitPriceWithPoints({ total_price: new_total_price, budget_points, points_ex_rate });

    if (!old_split || !new_split) {
        return { active: false };
    }

    return {
        active: true,
        old_points: old_split.points_spent,
        old_money: old_split.remaining_cash,
        new_points: new_split.points_spent,
        new_money: new_split.remaining_cash,
        points_delta: new_split.points_spent - old_split.points_spent,
        money_delta: new_split.remaining_cash - old_split.remaining_cash,
    };
}

module.exports = {
    getAvailablePointsBudget,
    splitPriceWithPoints,
    buildPointsRecheckSplit,
};
